import React, { useEffect, useState } from 'react';
import { DevMessageWrapper } from './styled';

const DevMessage = (props) => {
    const [frame, setFrame] = useState(0)
    const speed = 2;

    useEffect(() => { 
        const i = setInterval(()=> {
            setFrame(frame+1);
        },16)
        return () => clearInterval(i);
    }, [frame])

    return (
        <DevMessageWrapper>
            <article className='message-area'>
                    <svg viewBox="0 0 150 146" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            transform={'rotate(' + frame * speed + ',107 ,43 )'} 
                            className='gear'
                            id="gear1"
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M111.504 0L98.0188 0.682372L97.0024 17.5744C95.5538 18.1383 94.1672 18.8215 92.854 19.6115L79.2937 9.8448L70.2405 19.863L81.6217 32.7015C81.1295 33.9031 80.7208 35.1462 80.4025 36.4233L63.9097 39.1054L64.5921 52.5909L81.717 53.6213C82.1345 54.6163 82.609 55.5804 83.1361 56.5098L73.245 70.2428L83.2631 79.2959L95.9275 68.0691C97.1189 68.5937 98.3537 69.0354 99.6241 69.3871L102.34 86.0903L115.826 85.4079L116.842 68.5159C117.848 68.1242 118.825 67.675 119.767 67.1725L133.689 77.1996L142.742 67.1814L131.656 54.6763C132.21 53.5007 132.683 52.2804 133.067 51.023L150 48.2692L149.318 34.7837L132.638 33.7801C132.112 32.3165 131.464 30.9128 130.709 29.5804L140.6 15.8475L130.582 6.79436L117.917 18.0211C116.726 17.4966 115.491 17.0549 114.221 16.7031L111.504 0ZM107.361 51.7144C112.149 51.4721 115.834 47.3944 115.592 42.6065C115.349 37.8186 111.272 34.1336 106.484 34.3759C101.696 34.6182 98.0108 38.6959 98.2531 43.4838C98.4953 48.2717 102.573 51.9566 107.361 51.7144Z" 
                            />
                        <path 
                            transform={'rotate(' + frame * -speed + ',37 ,69 )'}
                            className='gear'
                            id="gear2"
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M33.6281 32.3602L22.3393 35.2207L24.3399 49.678C23.2104 50.4002 22.1535 51.2128 21.1767 52.1032L8.05527 46.1398L2.09556 56.1449L13.8943 65.075C13.6815 66.1744 13.5464 67.2949 13.4933 68.4288L0 73.4897L2.86049 84.7785L17.5171 82.7502C18.0387 83.5209 18.6031 84.2559 19.2062 84.9527L13.1669 98.2411L23.172 104.201L31.981 92.5622C33.0774 92.8041 34.1964 92.9685 35.3303 93.0509L40.4557 106.716L51.7445 103.856L49.7438 89.3986C50.5283 88.8971 51.2777 88.3519 51.9897 87.7673L65.4608 93.8897L71.4205 83.8847L59.9283 75.1864C60.1978 74.0984 60.3907 72.9864 60.5023 71.8581L74.3562 66.6621L71.4957 55.3733L57.2205 57.3487C56.5273 56.2002 55.7421 55.1227 54.8775 54.1239L60.9168 40.8355L50.9117 34.8758L42.1027 46.5144C41.0064 46.2725 39.8874 46.1081 38.7535 46.0257L33.6281 32.3602ZM38.8808 76.7954C42.8888 75.7798 45.3146 71.7074 44.299 67.6994C43.2834 63.6914 39.211 61.2656 35.203 62.2812C31.1951 63.2968 28.7692 67.3692 29.7848 71.3772C30.8004 75.3852 34.8728 77.811 38.8808 76.7954Z" 
                            />
                        <path 
                            transform={'rotate(' + frame * speed + ',74 ,118 )'}
                            className='gear'
                            id="gear3"
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M73.4283 90.0774L82.048 91.349L81.6572 102.262C82.4166 102.645 83.1422 103.08 83.8298 103.563L93.2618 98.058L98.4578 105.052L90.4642 112.493C90.774 113.432 91.0064 114.402 91.1548 115.394L101.583 118.136L100.311 126.756L89.2479 126.36C88.8462 127.107 88.3931 127.819 87.894 128.493L93.3294 137.807L86.3352 143.002L78.7921 134.899C78.1323 135.098 77.4578 135.259 76.7718 135.38L73.9949 145.94L65.3752 144.669L65.7661 133.756C65.0066 133.373 64.2811 132.938 63.5934 132.455L54.1614 137.96L48.9655 130.966L56.9591 123.525C56.743 122.87 56.5645 122.2 56.426 121.518L45.7196 118.703L46.9911 110.083L57.7664 110.469C58.1292 109.701 58.5448 108.966 59.008 108.268L53.4277 98.7061L60.4219 93.5102L67.7691 101.403C68.6999 101.069 69.6637 100.812 70.6515 100.638L73.4283 90.0774ZM79.253 118.826C78.8015 121.887 75.9546 124.002 72.8943 123.55C69.834 123.099 67.719 120.252 68.1705 117.192C68.6219 114.131 71.4688 112.016 74.5291 112.468C77.5895 112.919 79.7044 115.766 79.253 118.826Z" 
                            />
                    </svg>
                
                { props.title && 
                <>
                    <h1>{ props.title }</h1>
                    <h2>{ props.location ? props.location : window.location.href }</h2>
                    
                </>
                }
                { !props.title && 
                <>
                    <h1>{ props.location ? props.location : window.location.href }</h1> 
                </>
                }
                <p>{ props.message ? props.message : 'This part of the website is in development. Thank you for visiting my portfolio website!' }</p>
                
            </article>
        </DevMessageWrapper>
    )
}

export default DevMessage;
